'use client';

import { Align, Justify, Spacer, SpacerSize, Text, TextLevels, TrilogyColor, View } from '@bytel/trilogy-react';

import { Loader } from '@components/loader';

import { uiStore } from '@stores/ui';

function Loading() {
    const { loading } = uiStore();
    if (!loading.show) return null;
    return (
        <View
            flexable
            justify={Justify.CENTER}
            align={Align.CENTER}
            backgroundColor={TrilogyColor.BACKGROUND}
            className='is-fullscreen is-flex-col'
        >
            <Loader />
            <Spacer size={SpacerSize.FOUR} />
            <Text level={TextLevels.ONE} className='has-text-centered'>
                {loading.message}
            </Text>
        </View>
    );
}

export default Loading;
